/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_TermsInputs */

const en_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const zh_hans1_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务条款`)
};

const pt_br2_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos de Serviço`)
};

const es_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos del servicio`)
};

const fr_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions d’utilisation`)
};

const de_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbedingungen`)
};

const ru_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия использования`)
};

const it_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termini di servizio`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Footer_TermsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_terms = /** @type {((inputs?: Footer_TermsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_TermsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_terms(inputs)
	if (locale === "pt-BR") return pt_br2_footer_terms(inputs)
	if (locale === "es") return es_footer_terms(inputs)
	if (locale === "fr") return fr_footer_terms(inputs)
	if (locale === "de") return de_footer_terms(inputs)
	if (locale === "ru") return ru_footer_terms(inputs)
	if (locale === "it") return it_footer_terms(inputs)
	return en_footer_terms(inputs)
});